import { useState, useEffect } from 'react';
import { LOCATION_WITH_CHILDREN_ENDPOINTS } from '../constants/searchConstants';

export const useLocationWithChildren = () => {
  const [locationWithChildren, setLocationWithChildren] = useState<any[]>([]);

  useEffect(() => {
    Promise.all(LOCATION_WITH_CHILDREN_ENDPOINTS.map(endpoint =>
      fetch(endpoint)
        .then(res => res.json())
        .catch(_ => null)
    )).then(responses => {
      const validResponses = responses.filter(res => res && res.data && Array.isArray(res.data));

      const flattenedData = validResponses.map(res => res.data).flat();

      setLocationWithChildren(flattenedData);
    }).catch(error => {
    });
  }, []);

  return {
    locationWithChildren,
    setLocationWithChildren
  };
}; 